import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ReadMore = props => {
	const { children, className, charLength, labelText, as } = props;
	let [stringLength, setStringLength] = useState(charLength);
	let truncatedString = children.substr(0, stringLength);
  const Wrapper = as;
  const readMoreClass = classnames (
    className, {
      'c-pointer' : truncatedString.length !== children.length
    }
  )

	return (
		<Wrapper className={readMoreClass} onClick={() => setStringLength(children.stringLength)}>
			{truncatedString}
			{truncatedString.length !== children.length ? (
				<span>
					...
					<span className='flex c-secondary-500 mt-2 mb-0 c-pointer fs-inherit'>{labelText}</span>
				</span>
			) : null}
		</Wrapper>
	);
};

ReadMore.propTypes = {
	/**
	 * Class to be appended to the wrapping element
	 */
	className: PropTypes.string,
	/**
	 * Text appended after the ellipsis
	 */
	labelText: PropTypes.string,
	/**
	 * Number of characters to truncate after
	 */
	charLength: PropTypes.number,
	/**
	 * Text to be truncated
	 */
	children: PropTypes.string.isRequired,
	/**
	 * Element to wrapped the passed text
	 */
	as: PropTypes.oneOf(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'div', 'span'])
};
ReadMore.defaultProps = {
	className: '',
	labelText: 'Read more',
	charLength: 100,
	children: '',
	as: 'div'
};

ReadMore.displayName = 'ReadMore';

export { ReadMore };
